// extracted by mini-css-extract-plugin
export var linkList = "RichTextRenderer-module--link-list--2pAdT";
export var link = "RichTextRenderer-module--link--2p4xM";
export var downloadButton = "RichTextRenderer-module--download-button--1OKvD";
export var downloadButtonContainer = "RichTextRenderer-module--download-button-container--BPwHq";
export var seperator = "RichTextRenderer-module--seperator--_pcd-";
export var leftHolder = "RichTextRenderer-module--left-holder--3vZPQ";
export var rightHolder = "RichTextRenderer-module--right-holder--2hbJJ";
export var line = "RichTextRenderer-module--line--zcT9a";